<app-loader *ngIf="isDisabled || isGrouping"></app-loader>
<div class="p-2">
    <div class="row gx-3 gy-2 mb-2" style="justify-content:right">
        <div class="col"></div>
        <div class="col-md-3" *ngIf="mfilter.filterType == 1">
            <ngb-datepicker #dp [(ngModel)]="mfilter.FromDate" class="month-year"
                (navigate)="mfilter.FromDate= $event.next;onNavigate($event)"></ngb-datepicker>
        </div>
        <div class="col-md-2" *ngIf="mfilter.filterType == 2">
            <div class="input-group">
                <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateRange" [(ngModel)]="mfilter.FromDate"
                    ngbDatepicker #FromDate="ngbDatepicker" />
                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                    type="button"></button>
            </div>
        </div>
        <div class="col-md-2" *ngIf="mfilter.filterType == 2 || mfilter.filterType == 4">
            <div class="input-group">
                <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateRange" [(ngModel)]="mfilter.ToDate"
                    ngbDatepicker #ToDate="ngbDatepicker" />
                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                    type="button"></button>
            </div>
        </div>
        <div class="col-md-2">
            <select class="form-select" aria-label="filterType" placeholder="filterType" title="filterType"
                name="filterType" [(ngModel)]="mfilter.filterType" #filterType="ngModel" required>
                <option value='3'>Yesterday</option>
                <option value='0'>Today</option>
                <option value='1'>Monthly</option>
                <option value='4'>Date</option>
                <option value='2'>Date Range</option>
            </select>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="FetchData()">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Fetch Data':'Loading...'}}</button>
        </div>
    </div>
</div>

<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        Dashboard - Front Office
    </div>
    <div class="card-body p-1">
        <div class="p-2">
            <div class="row gx-3 gy-2 mb-2">
                <div class="col-md-3">
                    <ng-select [items]="ShiftGroups" [multiple]="true" bindLabel="ShiftGroupName"
                        bindValue="ShiftGroupMasterID" placeholder="All Shiftgroup" [closeOnSelect]="false"
                        [(ngModel)]="mfilter.ShiftGroupMasterID" [virtualScroll]="true"
                        (change)="DropdownChange('ShiftGroup')">

                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'ShiftGroup')" /> Check All
                        </ng-template>

                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.ShiftGroupName">{{item.ShiftGroupName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.ShiftGroupName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="Shifts" [multiple]="true" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                        placeholder="All Shift" [closeOnSelect]="false" [(ngModel)]="mfilter.ShiftMasterID"
                        [virtualScroll]="true">

                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Shift')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.ShiftTitle">{{item.ShiftTitle}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.ShiftTitle}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="Regions" [multiple]="true" bindLabel="RegionName" bindValue="RegionMasterID"
                        placeholder="All Region" [closeOnSelect]="false" [(ngModel)]="mfilter.RegionMasterID"
                        [virtualScroll]="true" (change)="DropdownChange('Region')">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Region')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.RegionName">{{item.RegionName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.RegionName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="Branchs" [multiple]="true" bindLabel="BranchName" bindValue="BranchMasterID"
                        placeholder="All Branch" [closeOnSelect]="false" [(ngModel)]="mfilter.BranchMasterID"
                        [virtualScroll]="true" (change)="DropdownChange('Branch')">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Branch')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.BranchName">{{item.BranchName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.BranchName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="row gx-3 gy-2 mb-2">
                <div class="col-md-3">
                    <ng-select [items]="Clients" [multiple]="true" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" placeholder="All Client" [closeOnSelect]="false"
                        [(ngModel)]="mfilter.ClientGroupMasterID" [virtualScroll]="true"
                        (change)="DropdownChange('Client')">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Client')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.ClientGroupName">{{item.ClientGroupName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.ClientGroupName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="Sites" [multiple]="true" bindLabel="SiteName" bindValue="SiteMasterID"
                        placeholder="All Site" [closeOnSelect]="false" [(ngModel)]="mfilter.SiteMasterID"
                        [virtualScroll]="true" (change)="DropdownChange('Site')">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'Site')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.SiteName">{{item.SiteName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.SiteName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="SiteOwners" [multiple]="true" bindLabel="SiteOwnerName" bindValue="SiteOwnerID"
                        placeholder="All Supervisor" [closeOnSelect]="false" [(ngModel)]="mfilter.SiteOwnerID"
                        [virtualScroll]="true">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'SiteOwner')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.SiteOwnerName">{{item.SiteOwnerName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.SiteOwnerName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="IndustrySegments" [multiple]="true" bindLabel="IndustrySegmentName"
                        bindValue="IndustrySegmentId" placeholder="All Segment" [closeOnSelect]="false"
                        [(ngModel)]="mfilter.IndustrySegmentId" [virtualScroll]="true">
                        <ng-template ng-header-tmp let-items="items">
                            <input type="checkbox" (change)="CheckAll($event,'IndustrySegment')" /> Check All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            <span [ngbTooltip]="item.IndustrySegmentName">{{item.IndustrySegmentName}}</span>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.IndustrySegmentName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="row gx-3 mb-2">
                <div class="col"></div>
                <div class="col-auto">
                    <button class="btn btn-primary" type="button" (click)="AttendanceDashboardGetData()"
                        [disabled]="isDisabled || isApply"><i class="bi bi-funnel me-2" *ngIf="!isApply"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isApply"></span>
                        {{!isApply?'Apply':'Applying...'}}
                    </button>
                </div>
            </div>
        </div>
        <div class="p-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-4 p-0">
                            <div class="row">
                                <div class="col-12">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 30px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #0078D4;color: #fff;">
                                                <i class="bi bi-people fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #EBF3FE;color: #0078D4;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <div class="col" style="text-align: left;">Total Billable</div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count"
                                                    style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                                    {{Card.Total}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12"
                                    *ngIf="this.common.CompanyParameterValue.ESS_DashboardTotalActiveCountEnabled">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 30px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #0078D4;color: #fff;">
                                                <i class="bi bi-person-raised-hand fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #EBF3FE;color: #0078D4;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <div class="col" style="text-align: left;">Total Active</div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count"
                                                    style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                                    {{Card.TotalActive}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 p-0">
                            <div class="row">
                                <div class="col-12">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 34px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #00d68f;color: #fff;">
                                                <i class="bi bi-person-check fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #E6FFFA;color: #00d68f;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <div class="col" style="text-align: left;">Present</div>
                                                        <div class="col-auto"
                                                            style="font-size:large; font-weight: 400;"><span
                                                                class="badge success"
                                                                style="background-color: #00d68f;height: auto;font-size: large;">{{Card.PresentPer}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                                    {{Card.Present}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 34px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #00A36C;color: #fff;">
                                                <i class="bi bi-person-check-fill fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #00a36d2e;color: #00A36C;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <!-- <div class="col" style="text-align: left;">Manual Attendance
                                                        </div> -->
                                                        <div class="col" style="text-align: left;">Digital Attendance
                                                        </div>
                                                        <div class="col-auto"
                                                            style="font-size:large; font-weight: 400;"><span
                                                                class="badge"
                                                                style="background-color: #00A36C;height: auto;font-size: large;">{{Card.OnlineAttendancePer}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                                    {{Card.OnlineAttendance}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 p-0">
                            <div class="row">
                                <div class="col-12">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 34px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #FF0000;color: #fff;">
                                                <i class="bi bi-person-x fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #FBF2EF;color: #FF0000;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <div class="col" style="text-align: left;">Absent</div>
                                                        <div class="col-auto"
                                                            style="font-size:large; font-weight: 400;"><span
                                                                class="badge danger"
                                                                style="background-color: #FF0000;height: auto;font-size: large;">{{Card.AbsentPer}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                                    {{Card.Absent}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="tile m-1">
                                        <div class="row g-0" style="line-height: 34px;">
                                            <div class="col-3 p-3 m-0 text-center"
                                                style="background-color: #6A0DAD;color: #fff;">
                                                <i class="bi bi-calendar-week fs-1"></i>
                                            </div>
                                            <div class="col-9 text-end p-0 m-0"
                                                style="background-color: #c999eb;color: #6A0DAD;">
                                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                                    <div class="row g-0">
                                                        <div class="col" style="text-align: left;">Weekoff</div>
                                                        <div class="col-auto"
                                                            style="font-size:large; font-weight: 400;"><span
                                                                class="badge"
                                                                style="background-color: #6A0DAD;height: auto;font-size: large;">{{Card.WOPer}}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                                    {{Card.WO}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card border-radius-0 m-1 p-0" id="Attendance">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Attendance</div>
                        <div class="col-auto">
                            <div class="form-check form-switch"
                                (click)="Collapsed.AttendanceGraph = !Collapsed.AttendanceGraph">
                                <input class="form-check-input toggle" type="checkbox" role="switch"
                                    [checked]="Collapsed.AttendanceGraph"
                                    (change)="onSwitchChange($event,'AttendanceGraph')">
                                <label class="form-check-label"
                                    [ngClass]="{'toggle-on':Collapsed.AttendanceGraph,'toggle-off':!Collapsed.AttendanceGraph}"
                                    for="flexSwitchCheckDefault">{{Collapsed.AttendanceGraph?'ON':'OFF'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0" #collapse="ngbCollapse" [(ngbCollapse)]="!Collapsed.AttendanceGraph">
                    <div class="chart-scroll-container">
                        <div class="chart-container">
                            <canvas baseChart [type]="'bar'" [data]="AttendanceChartData"
                                [options]="{responsive: true,maintainAspectRatio: false,scales: {x: {ticks: {maxRotation: 45,minRotation: 45,font: {size: 10}}},y: {ticks: {font: {size: 10}}}}}"
                                [legend]="ChartLegend.Attendance">
                            </canvas>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card border-radius-0 m-1 p-0">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Branch</div>
                        <div class="col-auto">
                            <div class="form-check form-switch"
                                (click)="Collapsed.BranchGraph = !Collapsed.BranchGraph">
                                <input class="form-check-input toggle" type="checkbox" role="switch"
                                    [checked]="Collapsed.BranchGraph" (change)="onSwitchChange($event,'BranchGraph')">
                                <label class="form-check-label"
                                    [ngClass]="{'toggle-on':Collapsed.BranchGraph,'toggle-off':!Collapsed.BranchGraph}"
                                    for="flexSwitchCheckDefault">{{Collapsed.BranchGraph?'ON':'OFF'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0" #collapse="ngbCollapse" [(ngbCollapse)]="!Collapsed.BranchGraph">
                    <div class="chart-scroll-container">
                        <div class="chart-container">
                            <canvas baseChart [type]="'bar'" [data]="BranchChartData"
                                [options]="{responsive: true,maintainAspectRatio: false,scales: {x: {stacked: true,ticks: {maxRotation: 45,minRotation: 45,font: {size: 10}}},y: {stacked: true,ticks: {font: {size: 10}}}}}"
                                [legend]="ChartLegend.Branch">
                            </canvas>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card border-radius-0 m-1 p-0">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Analytics</div>
                        <div class="col-auto"><button type="button" class="btn btn-primary btn-sm"
                                [disabled]="isDisabled" (click)="ExcelDump(0)">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                <i *ngIf="!isDisabled" class="bi bi-file-earmark-spreadsheet-fill"></i>
                                {{!isDisabled?'Excel':'Loading...'}}</button>
                        </div>
                        <div class="col-auto">
                            <div ngbDropdown class="d-inline-block" #groupDrop="ngbDropdown">
                                <button type="button" class="btn btn-outline-primary btn-sm" id="dropdownForm1"
                                    ngbDropdownToggle [disabled]="isDisabled || isGrouping">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                        *ngIf="isGrouping"></span>Grouping
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdownForm1" display="dynamic">
                                    <form class="px-4 py-3" (submit)="showGroup()">
                                        <label class="Label">
                                            <input type="checkbox" name="groupCheckall" (change)="CheckAllGroupBy()"
                                                [(ngModel)]="groupby.Checkall" ngbCheckbox />
                                            Select All
                                        </label><br />
                                        <label class="Label">
                                            <input type="checkbox" name="groupState" [(ngModel)]="groupby.State"
                                                ngbCheckbox />
                                            State
                                        </label><br />
                                        <label class="Label">
                                            <input type="checkbox" name="groupRegion" [(ngModel)]="groupby.Region"
                                                ngbCheckbox />
                                            Region
                                        </label><br />
                                        <label class="Label">
                                            <input type="checkbox" name="groupBranch" [(ngModel)]="groupby.Branch"
                                                ngbCheckbox /> Branch
                                        </label><br />
                                        <label class="Label">
                                            <input type="checkbox" name="groupClient" [(ngModel)]="groupby.Client"
                                                ngbCheckbox /> Client
                                        </label><br />
                                        <label class="Label">
                                            <input type="checkbox" name="groupSite" [(ngModel)]="groupby.Site"
                                                ngbCheckbox />
                                            Site
                                        </label><br />
                                        <div class="dropdown-divider"></div>
                                        <button type="submit" (click)="groupDrop.close();"
                                            class="btn btn-outline-primary btn-sm">Apply</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="form-check form-switch"
                                (click)="Collapsed.AttendanceAnalytics = !Collapsed.AttendanceAnalytics">
                                <input class="form-check-input toggle" type="checkbox" role="switch"
                                    [checked]="Collapsed.AttendanceAnalytics"
                                    (change)="onSwitchChange($event,'AttendanceAnalytics')">
                                <label class="form-check-label"
                                    [ngClass]="{'toggle-on':Collapsed.AttendanceAnalytics,'toggle-off':!Collapsed.AttendanceAnalytics}"
                                    for="flexSwitchCheckDefault">{{Collapsed.AttendanceAnalytics?'ON':'OFF'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body m-1" #collapse="ngbCollapse" [(ngbCollapse)]="!Collapsed.AttendanceAnalytics">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="summarydata"
                        class="customeDatatable table table-bordered" name="summarydata">
                    </table>
                </div>
            </div>

            <div class="card border-radius-0 m-1 p-0">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Employee Details</div>
                        <div class="col-auto">
                            <button *ngIf="empDatas.length > 0" type="button" class="btn btn-primary btn-sm"
                                [disabled]="isDisabled" (click)="ExcelDump(1)">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                <i *ngIf="!isDisabled" class="bi bi-file-earmark-spreadsheet-fill"></i>
                                {{!isDisabled?'Excel':'Loading...'}}</button>
                        </div>
                        <div class="col-auto">
                            <div class="form-check form-switch"
                                (click)="Collapsed.EmployeeDetails = !Collapsed.EmployeeDetails">
                                <input class="form-check-input toggle" type="checkbox" role="switch"
                                    [ngModel]="Collapsed.EmployeeDetails" (change)="$event.preventDefault();">
                                <label class="form-check-label"
                                    [ngClass]="{'toggle-on':Collapsed.EmployeeDetails,'toggle-off':!Collapsed.EmployeeDetails}"
                                    for="flexSwitchCheckDefault">{{Collapsed.EmployeeDetails?'ON':'OFF'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body m-1 overflow-auto" #collapse="ngbCollapse"
                    [(ngbCollapse)]="!Collapsed.EmployeeDetails">
                    <table datatable [dtOptions]="dtOptionsEmp" [dtTrigger]="dtTriggerEmp" id="empdatatable"
                        class="customeDatatable table table-bordered" name="empdatatable">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 5px;">#</th>
                                <th>Details</th>
                                <th>Shift Group</th>
                                <th>Shift Name</th>
                                <th>AttendanceDate</th>
                                <th>Attendance</th>
                                <th>InTime</th>
                                <th>OutTime</th>
                                <th>State Name</th>
                                <th>Branch Name</th>
                                <th style="width: 1000px;">Client Name</th>
                                <th style="width: 1000px;">Site Name</th>
                                <th style="width: 200px;">Supervisor Name</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>

            <div class="card border-radius-0 m-1 p-0" id="SummaryDetails">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Summary Details</div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary btn-sm" [disabled]="isDisabled"
                                (click)="ExcelDump(2)">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                <i *ngIf="!isDisabled" class="bi bi-file-earmark-spreadsheet-fill"></i>
                                {{!isDisabled?'Excel':'Loading...'}}</button>
                        </div>
                        <div class="col-auto">
                            <div class="form-check form-switch"
                                (click)="Collapsed.SummaryDetails = !Collapsed.SummaryDetails">
                                <input class="form-check-input toggle" type="checkbox" role="switch"
                                    [checked]="Collapsed.SummaryDetails"
                                    (change)="onSwitchChange($event,'SummaryDetails')">
                                <label class="form-check-label"
                                    [ngClass]="{'toggle-on':Collapsed.SummaryDetails,'toggle-off':!Collapsed.SummaryDetails}"
                                    for="flexSwitchCheckDefault">{{Collapsed.SummaryDetails?'ON':'OFF'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body m-1 overflow-auto" #collapse="ngbCollapse"
                    [(ngbCollapse)]="!Collapsed.SummaryDetails">
                    <table datatable id="summarydatatable" class="customeDatatable table table-bordered"
                        [dtOptions]="dtOptionsbranchSummary" [dtTrigger]="dtTriggerbranchSummary"
                        name="summarydatatable">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 5px;">#</th>
                                <th>Total Manpower</th>
                                <th>Total Punch</th>
                                <th>Total Pending</th>
                                <th
                                    [ngClass]="{'colHide': !this.common.CompanyParameterValue.ESS_DashboardTotalActiveCountEnabled}">
                                    Total Active</th>
                                <th>Branch Name</th>
                                <th>Site Count</th>
                                <th>Punch</th>
                                <th>Pending</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>